import "./emergency-access";
import EmergencyAccess from "../../../../../web-sh/src/pages/admin/settings/components/security/EmergencyAccess";

export default EmergencyAccess;